import { Component, OnInit } from '@angular/core';
import { JsLoaderService } from "src/shared/services/js-loader.service";
import { AppConfig } from "../../app-config";

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html'
})
export class MainComponent implements OnInit {

  constructor(private jsLoader: JsLoaderService, private config: AppConfig) { }
  IsPortal = this.config.IsPortal;

  ngOnInit() {
    this.jsLoader.loadScripts();
    console.log(this.IsPortal);
  }

}
